export function iterableReduce(iterable, func, defaultValue) {
    let acc = defaultValue, i = 0;
    for (const value of iterable)
        acc = func(acc, value, i++);
    return acc;
}
export function* iterableMap(iterable, func) {
    let i = 0;
    for (const value of iterable)
        yield func(value, i++);
}
export function* iterableFilter(iterable, func) {
    let i = 0;
    for (const value of iterable)
        if (func(value, i++))
            yield value;
}
export function iterableIncludes(iterable, searchValue) {
    for (const value of iterable)
        if (value === searchValue)
            return true;
    return false;
}
export function iterableFind(iterable, func) {
    let i = 0;
    for (const value of iterable)
        if (func(value, i++))
            return value;
    return null;
}
export function iterableFindIndex(iterable, func) {
    let i = 0;
    for (const value of iterable)
        if (func(value, i++))
            return i;
    return -1;
}
export function iterableIndexOf(iterable, searchValue) {
    let i = 0;
    for (const value of iterable) {
        if (value === searchValue)
            return i;
        i++;
    }
    return -1;
}
export function iterableSome(iterable, func) {
    let i = 0;
    for (const value of iterable)
        if (func(value, i++))
            return true;
    return false;
}
//# sourceMappingURL=iterableHelpers.js.map